module.exports = __webpack_public_path__ + "static/media/instagram.d754fc24.svg";